import { API_URL, setHeader } from 'api';
import axios from 'axios';

const URL = `${API_URL}/email`;

export const fetchEmailTemplates = () => {
  const req = setHeader(axios);
  return req.get(URL);
};

export const updateEmailTemplate = body => {
  const req = setHeader(axios);
  return req.put(URL, body);
};
